<template>
  <page>
    <div class="top-hero py-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="py-2 text-center font-weight-bold text-uppercase">97tax Services</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="description py-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <ul>
              <li class="mt-4 mb-4">
                <p class="main-black-text">
                  IRS Payment Plan Application - Completed IRS payment plan applications mailed to you within 24 hours with tracking information. Simply sign the application and mail to the IRS using the included prepaid envelope. <strong>Price: $97</strong>
                </p>
              </li>
              <li class="mb-4">
                <p class="main-black-text">
                  State of California Payment Plan Application - Completed Franchise Tax Board (FTB) payment plan applications mailed to you within 24 hours with tracking information. Simply sign the application and mail to the FTB using the included prepaid envelope. <strong>Price: $97</strong>
                </p>
              </li>
              <li class="mb-4">
                <p class="main-black-text">
                  State of New Jersey Payment Plan Application - Completed Division of Taxation payment plan applications mailed to you within 24 hours with tracking information. Simply sign the application and mail to the Division of Taxation using the included prepaid envelope. <strong>Price: $97</strong>
                </p>
              </li>
              <li class="mb-4">
                <p class="main-black-text">
                  State of Georgia Payment Plan Application- Completed Department of Revenue payment plan applications mailed to you within 24 hours with tracking information. Simply sign the application and mail to the Department of Revenue using the included prepaid envelope. <strong>Price: $97</strong>
                </p>
              </li>
              <li class="mb-4">
                <p class="main-black-text">
                  State of Illinois Payment Plan Application- Completed Department of Revenue payment plan applications mailed to you within 24 hours with tracking information. Simply sign the application and mail to the Department of Revenue using the included prepaid envelope. <strong>Price: $97</strong>
                </p>
              </li>
              <li class="mb-4">
                <p class="main-black-text">
                  State of Michigan Payment Plan Application- Completed Department of Treasury payment plan applications mailed to you within 24 hours with tracking information. Simply sign the application and mail to the Department of Treasury using the included prepaid envelope. <strong>Price: $97</strong>
                </p>
              </li>
              <li class="mb-4">
                <p class="main-black-text">
                  IRS Tax Lien Removal Application - Completed IRS tax lien removal application mailed to you within 24 hours with tracking information. Simply sign the application and mail to the IRS using the included prepaid envelope. <strong>Price: $97</strong>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<!-- sharea sale tag -->
<script>
  var shareasaleSSCID=shareasaleGetParameterByName("sscid");
function shareasaleSetCookie(e,a,r,s,t){
      if(e&&a)
            {var o,n=s?"; path="+s:"",i=t?"; domain="+t:"",l="";r&&((o=new Date).setTime(o.getTime()+r),l="; expires="+o.toUTCString()),
        document.cookie=e+"="+a+l+n+i
      }}
        function shareasaleGetParameterByName(e,a)
        {a||(a=window.location.href),e=e.replace(/[\[\]]/g,"\\$&");
        var r=new RegExp("[?&]"+e+"(=([^&#]*)|&|#|$)").exec(a);
return r?r[2]?decodeURIComponent(r[2].replace(/\+/g," ")):"":null}
shareasaleSSCID&&shareasaleSetCookie("shareasaleSSCID",
shareasaleSSCID,94670778e4,"/");
</script>

<style scoped>
  * {
    font-family: 'Raleway', sans-serif;
  }
  .top-hero {
    background-color: #0094be;
  }
  .top-hero h1 {
    color: #fff;
  }
  ul {
    list-style: none;
    padding-inline-end: 40px;
  }
  ul li p::before {
    content: "\2022";
    color: #0094be;
    font-size: 34px;
    font-weight: bold;
    display: inline-block;
    width: 28px;
    margin-left: -32px;
    vertical-align: middle;
  }

  li p {
    line-height: 2em;
  }

  .main-black-text {
    color: #424242;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Services.vue